import React from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "@components/tailwindComponents";
import Button from "@components/tailwindComponents/Button";
import BlackTooltip from "@components/tooltip/BlackTooltip";
import { BLANK_PROFILE_PICTURE } from "@helpers/_constants";
import { formatValidDate } from "@helpers/_functions";
import { useAccessFolderEnterprise } from "@hooks/employeFolder";
import { IconeNoteEntretient } from "@routes/IconeSvg";

export default function ItemsTables({indisponibility, toGoToFile}) {
  const {t} = useTranslation("pages.employés.indisponibility");
  const {canSeeEmployeFolder, getButtonVariant, goToEmployerFolder} = useAccessFolderEnterprise();
  const {
    employer,
    beginningOfPeriod,
    endOfPeriod,
    type,
    place,
    mainCause,
    injuryNature,
    bodyLocation,
    gravity,
    wastedTime,
    workStop,
    notes
  } = indisponibility;

  const onClickDocToFile = () => {
    if (goToEmployerFolder({
      employerId: employer?._id,
      employerSalaryId: employer?.jobAndsalaryId,
      addParamLink: "true"
    }))
      toGoToFile();
  };

  return (
    <tr className="arh-border arh-border-solid arh-border-borderTable arh-border-t-0 arh-border-x-0 hover:arh-bg-greyColor">
      <td className="arh-py-4 arh-px-4">
        <Avatar
          src={employer?.profile || BLANK_PROFILE_PICTURE}
          name={employer?.fullName}
          textStyle="desktop-middle:arh-w-24 arh-max-w-[12rem]  arh-truncate arh-font-poppins arh-font-medium arh-text-xs !arh-text-[#5a5a5a]"
        />
      </td>

      <td className="arh-whitespace-nowrap arh-px-4">
        <div className="arh-w-full arh-flex arh-flex-nowrap arh-items-center arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs arh-whitespace-nowrap ">
          {t("Du")}&nbsp; <span> {formatValidDate(beginningOfPeriod)}</span>
          &nbsp;{t("Au")}&nbsp;<span> {formatValidDate(endOfPeriod)}</span> 
        </div>
      </td>
      <td className="arh-px-4">
        <BlackTooltip title={type} placement="top-start">
          <div className="arh-w-40 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs arh-line-clamp-2">
            {type}
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-px-4">
        <BlackTooltip title={place} placement="top-start">
          <div className="arh-w-40 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs arh-line-clamp-2">
            {place || "-"}
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-px-4">
        <BlackTooltip title={mainCause} placement="top-start">
          <div className="arh-w-40 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs arh-line-clamp-2">
            {mainCause || "-"}
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-px-4">
        <BlackTooltip title={injuryNature} placement="top-start">
          <div className="arh-w-40 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs arh-line-clamp-2">
            {injuryNature || "-"}
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-px-4">
        <BlackTooltip title={bodyLocation} placement="top-start">
          <div className="arh-w-40 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs arh-line-clamp-2">
            {bodyLocation || "-"}
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-px-4">
        <BlackTooltip title={gravity} placement="top-start">
          <div className="arh-w-40 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs arh-line-clamp-2">
            {gravity || "-"}
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-px-4">
        <div className="arh-w-32 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs">
          {typeof wastedTime === 'boolean' ? wastedTime ? t("Oui") : t("Non") : "-"}
        </div>
      </td>
      <td className="arh-px-4">
        <div className="arh-w-32 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs">
          {typeof workStop === 'boolean' ? workStop ? t("Oui") : t("Non") : "-"}
        </div>
      </td>

      <td className="arh-px-4">
        {notes ? (
          <BlackTooltip title={notes} placement="top-start">
            <div className="arh-w-40 arh-font-poppins arh-font-medium arh-text-darkGreyColor arh-text-xs arh-line-clamp-2">
              {notes || "-"}
            </div>
          </BlackTooltip>
        ) : (
          <>
            {IconeNoteEntretient()}</>
        )}
      </td>

      <td className="arh-px-4">
        {canSeeEmployeFolder &&
          <div className="arh-flex arh-justify-end arh-items-center arh-mx-4">
            <Button
              onClick={onClickDocToFile}
              className=" arh-mr-[0.3rem]"
              variant={getButtonVariant(employer?._id)}
            >
              {t("Voir le dossier")}
            </Button>
          </div>
        }
      </td>
    </tr>
  );
}
